import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { RouteHistoryProvider } from './route-history-context/provider';
import { ThemeContextProvider } from './theme-context/provider';
import { SupportedSocialMediaProvider } from './supported-social-media-context/provider';
import { AuthContextProvider } from './auth-context/provider';
import { HelmetProvider } from 'react-helmet-async';
import { ProjectMetadataContextProvider } from './project-metadata-context/provider';
import AppStateProvider from './app-state-context/provider';

const MainContexts: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <HelmetProvider>
      <ThemeContextProvider>
          <AuthContextProvider>
            <RouteHistoryProvider>
              <SupportedSocialMediaProvider>
                <ProjectMetadataContextProvider>
                  <AppStateProvider>
                    <Suspense fallback={<div>Cargando...</div>}>
                      {children ?? <Outlet />}
                    </Suspense>
                  </AppStateProvider>
                </ProjectMetadataContextProvider>
              </SupportedSocialMediaProvider>
            </RouteHistoryProvider>
          </AuthContextProvider>
      </ThemeContextProvider>
    </HelmetProvider>
  );
};

export default MainContexts;
